<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
    <div class="card-toolbar">
      <div class="nav-item" *ngIf="followUp && followUp.id > 0" style="cursor: pointer">
        <a
          class="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style="padding-right: 0"
        >
          <span class="nav-icon">
            <button
              matTooltip="Comments"
              class="btn btn-sm btn-clean mr-2 header-buttons"
              mat-button
            >
              <i class="flaticon-comment"></i>
            </button>
          </span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-xl dropdown-menu-right px-5"
          (click)="$event.stopPropagation()"
          style="
            width: 500px;
            position: absolute;
            will-change: transform;
            padding: 0 !important;
            top: 0;
            left: 0;
            transform: translate3d(1065px, 59px, 0px);
            overflow: hidden;
            border-radius: 0;
          "
        >
          <kt-comments
            *ngIf="mode === 'UPDATE'"
            (seeAll)="seeAllComments($event)"
            [seeAllShow]="true"
            [id]="data.body ? data.body.id : data.body_id"
            [followup_id]="followUp.id"
            [comments]="comments"
            [type]="data.type"
            [height]="65"
          ></kt-comments>
        </div>
      </div>
      <div
        class="nav-item"
        *ngIf="followUp && followUp.id > 0"
        style="cursor: pointer"
        (click)="openHistory()"
      >
        <a
          class="nav-link"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          style="padding-right: 0"
        >
          <h6>{{ attempts_count }} Attempts</h6>
        </a>
      </div>
    </div>
  </div>
</div>
<form class="form" [formGroup]="followUpForm" autocomplete="off">
  <div class="navi-hover card-body py-3">
    <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
      {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
    </kt-alert>
    <div class="form-section form-section-first">
      <div class="form-group py-0">
        <div class="row">
          <div
            class="col-9"
            style="max-height: 70vh"
            [perfectScrollbar]="{ wheelPropagation: false }"
          >
            <div class="d-flex align-items-center mb-2">
              <button
                style="text-decoration: underline !important"
                class="btn btn-link font-size-lg font-weight-bold text-left w-100 px-0"
                (click)="openTransaction()"
              >
                {{ getName() | titlecase
                }}{{ getTitleOfType() ? ' : ' + (getTitleOfType() | titlecase) : '' }}
              </button>
            </div>
            <kt-general-autocomplete
              [label]="'Created by'"
              [loadItemsFunction]="userAutocompleteCall"
              [optionFormatter]="displayUsers"
              [valueFormatter]="displayUsersSelected"
              [required]="true"
              [readOnly]="true"
              [control]="followUpForm.get('createdBy')"
              [change]="onCreatedByChange.bind(this)"
              [placeholder]="'Search User'"
              [dataPath]="'data'"
              [appearance]="'standard'"
              #createdByAutocomplete
            ></kt-general-autocomplete>
            <kt-general-autocomplete
              [label]="'Contact'"
              [loadItemsFunction]="contactAutocompleteCall"
              [optionFormatter]="stringUtils.displayName"
              [valueFormatter]="stringUtils.displayName"
              [required]="false"
              [readOnly]="viewMode"
              [control]="followUpForm.get('followupContact')"
              [change]="onContactChange.bind(this)"
              [dataPath]="'data'"
              [appearance]="'standard'"
              [placeholder]="'Select Contact'"
              #followupContactAutocomplete
            ></kt-general-autocomplete>
            <kt-general-autocomplete
              [appearance]="'standard'"
              [label]="'Related Patients'"
              [loadItemsFunction]="relatedPatientsAutocompleteCall"
              [optionFormatter]="stringUtils.autocompleteEntityFormatter"
              [valueFormatter]="stringUtils.displayName"
              [required]="false"
              [readOnly]="!contactId || viewMode"
              [control]="followUpForm.get('relatedPatients')"
              [change]="onRelatedPatientsChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Patients'"
              [chipList]="true"
              [objects]="followUpForm.get('relatedPatients').value"
              [formatNewObjectFn]="formatNewAssigneeFn"
              #relatedPatientsAutocomplete
            ></kt-general-autocomplete>
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Follow-up Note</mat-label>
              <textarea
                matInput
                placeholder="Follow-up Note"
                formControlName="followupNote"
                rows="7"
                [readonly]="viewMode"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="col-3 pr-3 follow-up-panel">
            <div class="col-lg-12">
              <mat-form-field class="mat-form-field-fluid" appearance="standard">
                <mat-label>{{ 'TABLE.STATUS' | translate }}</mat-label>
                <mat-select
                  formControlName="status"
                  (selectionChange)="disableSaveButton = false"
                  placeholder="{{ 'TABLE.STATUS' | translate }}"
                >
                  <mat-option value="ACTIVE">Active</mat-option>
                  <mat-option value="COMPLETED">Completed</mat-option>
                  <mat-option value="CANCELLED">Cancelled</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <mat-form-field
                class="due-date-field mat-form-field-fluid"
                appearance="standard"
                *ngIf="mode === 'UPDATE'"
              >
                <mat-label>Follow-up Date</mat-label>
                <input
                  [owlDateTime]="dt1"
                  matInput
                  [readonly]="viewMode"
                  [placeholder]="'Follow-up Date'"
                  class="clendar-btn"
                  formControlName="followupDate"
                  (click)="openNewAttemptDialog()"
                />
                <owl-date-time class="clickable" [hour12Timer]="true" #dt1></owl-date-time>
                <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix
                  >access_time</mat-icon
                >
              </mat-form-field>
              <mat-form-field
                class="due-date-field mat-form-field-fluid"
                appearance="standard"
                *ngIf="mode === 'CREATE'"
              >
                <mat-label>Follow-up Date</mat-label>
                <input
                  [owlDateTime]="dt1"
                  matInput
                  [readonly]="viewMode"
                  [placeholder]="'Follow-up Date'"
                  class="clendar-btn"
                  formControlName="followupDate"
                />
                <owl-date-time [disabled]="viewMode" [hour12Timer]="true" #dt1></owl-date-time>
                <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix
                  >access_time</mat-icon
                >
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <kt-general-autocomplete
                [appearance]="'standard'"
                [label]="'Assign To'"
                [loadItemsFunction]="loadAssign"
                [optionFormatter]="filterAssigneeFn"
                [valueFormatter]="filterAssigneeFn"
                [required]="false"
                [readOnly]="viewMode"
                [control]="followUpForm.get('assignedTo')"
                [change]="onAssigneeChange.bind(this)"
                [dataPath]="'data'"
                [placeholder]="'Select Assignees'"
                [formatNewObjectFn]="formatNewAssigneeFn"
                [chipList]="true"
                [objects]="followUpForm.get('assignedTo').value"
                #assigneeAutocomplete
              ></kt-general-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="card-footer">
  <div class="row">
    <div class="col-lg-3">
      <button
        type="button"
        mat-raised-button
        color="primary"
        *ngIf="mode === 'UPDATE'"
        (click)="openNewAttemptDialog()"
        matTooltip="New Attempt"
      >
        <span>New Attempt</span></button
      >&nbsp;
    </div>
    <div class="col-lg-9" style="text-align: right">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        matTooltip="Create"
        [disabled]="viewMode && disableSaveButton"
      >
        <span translate="GLOBAL.SAVE">Save</span></button
      >&nbsp;
      <button (click)="close()" type="button" mat-raised-button cdkFocusInitial matTooltip="Cancel">
        <span translate="GLOBAL.CANCEL">Cancel</span>
      </button>
    </div>
  </div>
</div>
